import { z } from 'zod';
// POST /api/assignments body
export const CreateAssignmentSchema = z.object({
    landlord_id: z.number().int().positive(),
    agent_id: z.number().int().positive(),
    expires_at: z.string().datetime().optional(),
});
// Assignment response shape
export const AssignmentSchema = z.object({
    id: z.number().int(),
    landlordId: z.number().int(),
    landlordName: z.string().nullable(),
    managerId: z.number().int().nullable(),
    agentId: z.number().int().nullable(),
    agentName: z.string().nullable(),
    assignedAt: z.string().datetime(),
    active: z.boolean(),
});
// Assignment query params
export const AssignmentQuerySchema = z.object({
    agent_id: z.coerce.number().int().positive().optional(),
    area_id: z.coerce.number().int().positive().optional(),
});
//# sourceMappingURL=assignment.js.map